module.exports = __webpack_public_path__ + "img/image.c205c90d.svg";